import CONFIG from 'config';
import RcsUtils from './utils/RcsUtils';
import FetchUtils from './utils/FetchUtils';
import NotificationFooterBar from './boxes/NotificationFooterBar';
import desktopAreas from './areas/desktopAreas';

/**
 * This class handle my Component.
 */
class RcsCorHpLazyLoadingComponent {
  constructor(flavor) {
    this.justDownoloadMixedZone = false;
    this.flag = false;
    this.flavor = flavor;
    this.areas = this.flavor === 'mobile' ? [] : desktopAreas;
  }

  startDownloadMixed() {
    if (!this.justDownoloadMixedZone) {
      this.justDownoloadMixedZone = true;
      window.onscroll = null;
      this.fetchData(htmls => {
        htmls.forEach((html, i) => {
          if (html) {
            let area = this.areas[i];
            this.parseSection(area, html);
          }
        });
        RcsUtils.triggerEvent('hpLazyHtmlIsLoaded', document);
      });
    }
  }

  render() {
    if (this.flavor === 'mobile') {
      let footerBarInit = new NotificationFooterBar();
      footerBarInit.render();
    } else if (
      typeof rcsOrchestrator !== 'undefined' &&
      rcsOrchestrator.eventManager.isEventTriggered('load')
    ) {
      this.startDownloadMixed();
    } else {
      window.onload = () => {
        this.startDownloadMixed();
      };

      window.onscroll = () => {
        let y = window.pageYOffset || document.documentElement.scrollTop;
        if (y >= 50) {
          this.startDownloadMixed();
        }
      };
    }
  }

  parseSection(area, data) {
    if (area.where) {
      let isWhereFunc = area.where instanceof Function;
      let html = FetchUtils.arrayBufferToString(data);
      if (isWhereFunc) {
        area.where(area, html);
      } else {
        area.where.innerHTML = html;
      }
      RcsUtils.applyLazyLoad();
      if (area.init) {
        area.init();
      }

      RcsUtils.triggerEvent(area.event, isWhereFunc ? document : area.where, {
        value: html
      });
    }
  }

  fetchData(callback) {
    Promise.all(
      this.areas.map(URLmap =>
        fetch(`${CONFIG.apiPrefix}${URLmap.url}`).then(
          response => (response.ok ? response.arrayBuffer() : null)
        )
      )
    ).then(values => callback(values));
  }
}

module.exports = RcsCorHpLazyLoadingComponent;



// WEBPACK FOOTER //
// ./src/rcs_cor_hp-lazy-loading/rcs_cor_hp-lazy-loading.component.js